var React = require('react');

function Contract24Inline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"contract"),React.createElement("g",{"id":"contract-24","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M22,1 L22,23 L2,23 L2,1 L22,1 Z M20,3 L4,3 L4,21 L20,21 L20,3 Z M18,17 L18,19 L6,19 L6,17 L18,17 Z M7,12 L10,15 L7,15 L7,12 Z M14.3284271,5.55025253 L16.4497475,7.67157288 L10.6715729,13.4497475 L8.55025253,11.3284271 L14.3284271,5.55025253 Z","id":"Combined-Shape","fill":"#000000","fillRule":"nonzero"}))]);
}

Contract24Inline.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Contract24Inline;

Contract24Inline.default = Contract24Inline;
